"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCdnUrl = exports.getConfigUrl = exports.getRemoteEntryUrl = exports.getHostsConfigUrl = exports.getRemotesConfigUrl = exports.getEntryAssetsUrl = exports.getAppAssetUrl = void 0;
var utils_isomorphic_1 = require("@clover-microapp/utils-isomorphic");
function getOrigin(useDev) {
    if (useDev)
        return utils_isomorphic_1.CDN_CONFIG.dev.host;
    var win = window;
    var top = win.originTop ? win.originTop : win.top;
    var topLocation = top ? top.location : win.location;
    var cdnMatch = Object.values(utils_isomorphic_1.CDN_CONFIG).find(function (entry) { return entry.envPattern.test(topLocation.origin); });
    return cdnMatch ? cdnMatch.host : topLocation.origin;
}
function buildCdnUrl(path, useDevCdn) {
    var prefix = path.indexOf("".concat(utils_isomorphic_1.CDN_PREFIX_PATH, "/")) === 0 ? '' : utils_isomorphic_1.CDN_PREFIX_PATH;
    return "".concat(getOrigin(useDevCdn)).concat(prefix).concat(path);
}
exports.buildCdnUrl = buildCdnUrl;
function getRemotesConfigUrl(namespace, env) {
    return buildCdnUrl((0, utils_isomorphic_1.getRemotesConfigPath)(namespace, env));
}
exports.getRemotesConfigUrl = getRemotesConfigUrl;
function getHostsConfigUrl(namespace, env) {
    return buildCdnUrl((0, utils_isomorphic_1.getHostsConfigPath)(namespace, env));
}
exports.getHostsConfigUrl = getHostsConfigUrl;
function getRemoteEntryUrl(appConfig) {
    return buildCdnUrl((0, utils_isomorphic_1.getRemoteEntryPath)(appConfig), (0, utils_isomorphic_1.isPreviewVersion)(appConfig.version));
}
exports.getRemoteEntryUrl = getRemoteEntryUrl;
function getEntryAssetsUrl(appConfig) {
    return buildCdnUrl((0, utils_isomorphic_1.getEntryAssetsPath)(appConfig), (0, utils_isomorphic_1.isPreviewVersion)(appConfig.version));
}
exports.getEntryAssetsUrl = getEntryAssetsUrl;
function getConfigUrl(appId, version, namespace) {
    return buildCdnUrl((0, utils_isomorphic_1.getConfigPath)(appId, version, namespace), (0, utils_isomorphic_1.isPreviewVersion)(version));
}
exports.getConfigUrl = getConfigUrl;
function getAppAssetUrl(path, useDevCdn) {
    return buildCdnUrl(path.charAt(0) !== '/' ? "/".concat(path) : path, useDevCdn);
}
exports.getAppAssetUrl = getAppAssetUrl;
//# sourceMappingURL=dynamic-urls.js.map